<!--
 * CA锁、扫码公用弹窗
 * @author 滕威
 * @time 2022-06-02
 *
-->
<!-- VUE模板(html)代码 start -->
<template>
  <el-dialog
    class="dialog calockDialog"
    title="CA锁"
    @opened="fun_Open"
    :visible.sync="dialogCalock"
    :close-on-click-modal="false"
    :append-to-body="true"
    :width="type === 'word' ? '408px' : '550px'"
    @close="fun_Close"
    v-if="dialogCalock"
  >

    <div class="wordDecrypt">
      <p class="tips">
        请输入CA锁密码
        <el-tooltip class="item" popper-class="comTipspopper listPoperTip" effect="light" placement="bottom">
          <div slot="content" class="content">
            <p>1、颐信（初始密码为6个1）</p>
            <p>2、信达（初始密码为12345678）</p>
            <p>3、中金（初始密码为123456）</p>
            <p>4、湖北CA（初始密码为8个1）</p>
          </div>
          <div class="tip">
            <i class="el-icon-info"></i>
          </div>
        </el-tooltip>
      </p>
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item
          label=""
          prop="password"
          :rules="[{ required: true, message: '密码不能为空' }]"
        >
          <el-input
            type="password"
            placeholder="请输入CA锁密码"
            v-model="form.password"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button class="comBtn" @click="fun_Decrypt">确定</el-button>
    </div>
    <div class="btn"></div>
  </el-dialog>
</template>
<!-- VUE模板(html)代码 end -->

<script>
// 引入axios方法
import { fun_PostAction } from "@/api";
import VueQr from "vue-qr";
import {
  fun_IsIe,
  fun_GetLockNumber,
  fun_GetExpirationDate,
  fun_GetOrgId,
  fun_CheckLockBrand,
  fun_SignMessageP7,
  fun_ECCAInit
} from "../../utils/commonLock";
import { Loading } from "element-ui";
export default {
  data: () => {
    return {
      dialogCalock: false,
      i: 0,
      type: "word",
      btnList: ["CA锁"],
      form: {
        password: null
      },
      // 签名数据
      data: null,
      // 锁编号
      lockNo: null,
      // 锁品牌
      lockBrand: null,
      // 证书到期时间
      expirationDate: null,
      // 组织机构代码
      orgCd: null,
      // 签名后数据
      digitalSignature: null,
      // 状态 提交或保存
      state: null,
      // 全局加载
      fullLoading: null,
      // 页面类型 seal盖章
      pageType: null,
      // 甲方确认
      tenderSigned: null,
      // 甲方确认表单
      tenderSignedForm:{
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, //数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
      },
    };
  },
  components: {
    VueQr
  },
  mounted() {
    // 清空表单
    this.fun_ClearForm();
  },
  methods: {
    fun_Open() {
      this.fun_Change(0);
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text:
          this.state === "tj"
            ? "提交中..."
            : this.state === "tg"
            ? "通过中..."
            : this.state === "th"
            ? "退回中..."
            : "请稍作等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 清空数据
     * @author zhouzhou
     */
    fun_ClearForm() {
      if (this.$refs.form) {
        // 清空密码
        this.form.password = null;
        this.$refs.form.resetFields();
      }
      // 签名
      this.data = null;
      // 锁编号
      this.lockNo = null;
      // 锁品牌
      this.lockBrand = null;
      // 证书到期时间
      this.expirationDate = null;
      // 组织机构代码
      this.orgCd = null;
      // 签名后数据
      this.digitalSignature = null;
      // 跳到ca锁选项
      this.fun_Change(0);
    },
    /**
     * tab切换
     * @author tengwei
     */
    fun_Change(index) {
      // 清空密码
      this.form.password = null;
    },
    /**
     * 提交
     * @author zhouhzou
     */
    fun_Decrypt() {
      // 初始化
      fun_IsIe();
      // 表单验证
      this.$refs.form.validate(valid => {
        // 验证成功
        if (valid) {
          // 数字签名
          this.fun_CheckCaInfoAndDigitalSignature();
        }
      });
    },
    /**
     * 弹窗关闭
     * @author tengwei
     */
    fun_Close() {
      // 清空数据
      this.fun_ClearForm();
    },
    /**
     * 数字签名
     * @param state 状态， 提交还是保存
     * @param data 需要签名的数
     * @param loadding
     * @param functionName
     */
    fun_CheckCaInfoAndDigitalSignature() {
      // 提交场合
      if (this.state == "tj" || this.state == "tg" || this.state == "th") {
        // 启动加载框
        this.fun_Loading();
        // CA自动检测
        this.lockBrand = fun_CheckLockBrand();
        // 是否检测到锁品牌
        if (this.lockBrand == "" || this.lockBrand == null) {
          // 加载框取消
          this.fullLoading.close();
          // 提示
          this.$alert("请检查是否插入CA锁或者是否安装CA驱动，请确认后重新提交！", "warning");
          return;
        }
        // 控件初始化
        if (!fun_ECCAInit()) {
          // 加载框取消
          this.fullLoading.close();
          return;
        }
        // 锁编号
        this.lockNo = fun_GetLockNumber();
        // 证书到期日
        this.expirationDate = fun_GetExpirationDate();
        // 获取组织机构代码
        this.orgCd = fun_GetOrgId();
        // 数字签名数据为空的场合
        if (this.data == "" || this.data == null) {
          // 加载框取消
          this.fullLoading.close();
          // 提示
          this.$alert("数字签名数据为空，请重新操作！", "warning");
          return;
        }
        // AJAX异步通信
        fun_PostAction("/caLock/checkCorpCA?lockBrand=" + this.lockBrand + "&lockNo=" + this.lockNo + "&orgCd=" + this.orgCd + "&expirationDate=" + this.expirationDate).then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 判断请求是否成功
          if (result) {
            // 数字签名
            this.fun_DigitalSignature(data);
          } else {
            // 加载框取消
            this.fullLoading.close();
            // 提示信息
            this.$message.error(msg);
          }
        });
      } else {
        // 甲方确认的场合
        if(this.tenderSigned == 'tj' || this.tenderSigned == 'th'){
          // 甲方确认提交
          this.fun_TenderStampSubmit();
        }else{
          // 招标文件和资格预审文件盖章请求
          if (this.pageType && this.pageType === "seal") {
            // 页面的保存动作
            this.$parent.$parent.fun_SaveOrUpdate(this.state, null, null, "ca");
          }
          // 提交
          else {
            // 页面的保存动作
            this.$parent.fun_SaveOrUpdate(this.state, null, null, "ca");
          }
        }
      }
    },
    /**
     * 数字签名
     * @param obj ca验证返回的数据
     * @param functionName 回到函数
     * @returns {boolean}
     */
    fun_DigitalSignature(obj) {
      // 锁编号
      let lockNo = obj.serialNumber;
      // 数字签名
      this.digitalSignature = fun_SignMessageP7(this.data, this.form.password);
      // 锁编号为空的场合
      if (lockNo == "" || lockNo == null) {
        // 加载框取消
        this.fullLoading.close();
        this.$alert( "未取得锁编号，请重新操作！\r\n如再次操作不成功，请联系CA证书服务商！","warning");
        return;
      }
      // 数字签名为空的场合
      if (this.digitalSignature == "" || this.digitalSignature == null) {
        // 加载框取消
        this.fullLoading.close();
        this.$alert("电子签名不成功，请重新操作！\r\n如再次操作不成功，请联系CA证书服务商！","warning");
        return;
      }
      // 加载框取消
      this.fullLoading.close();
      // 清空密码
      this.form.password = null;
      // 甲方确认的场合
      if(this.tenderSigned == 'tj' || this.tenderSigned == 'th'){
        // 甲方确认提交
        this.fun_TenderStampSubmit();
      }else{
        // 招标文件和资格预审文件盖章请求
        if (this.pageType && this.pageType === "seal") {
          // 页面的保存动作
          this.$parent.$parent.fun_SaveOrUpdate(this.state, lockNo, this.digitalSignature, "ca");
        }
       else{
          // 页面的保存动作
          this.$parent.fun_SaveOrUpdate(this.state, lockNo, this.digitalSignature, "ca");
        }
      }
    },
    /**
     * 招标人提交
     */
    fun_TenderStampSubmit(){
      // 正常提交
      if(this.tenderSigned == 'tj'){
        // 询问框
        this.$confirm('您确定进行盖章确认吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 全局加载框
          this.fullLoading = Loading.service({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.8)"
          });
          try{
            // 请求
            fun_PostAction("/tenderStamp/tenderStampSubmit", {
              ...this.tenderSignedForm,
              lockNo: this.lockNo, // 锁编号
              digitalSignature: this.digitalSignature, // 数字签名
            }).then(res => {
              // 加载框取消
              this.fullLoading.close();
              // 解构res.data
              const { result, msg } = res.data;
              // 解析后台返回的结果集，判断是否成功
              if (result) {
                // 操作成功
                this.$message.success(msg);
                // 返回一览
                this.$parent.fun_Back();
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
              // 关闭loading
              this.loading = false;
            });
          } catch (e) {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("操作失败！" + e);
            // 加载框取消
            this.fullLoading.close();
          }
        });
      }
      // 退回至招标代理
      else if(this.tenderSigned == 'th'){
        // 提示消息
        let msg = "";
        // 存在招标人盖章确认的场合
        if(this.tenderSignedForm.isDeregulation == '1'){
          msg = "您确定取消提交吗？";
        }else{
          msg = "您确定将该信息退还至招标代理吗？";
        }
        // 询问框
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 全局加载框
          this.fullLoading = Loading.service({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.8)"
          });
          try{
            // 请求
            fun_PostAction("/tenderStamp/tenderStampRemove", {
              ...this.tenderSignedForm,
              lockNo: this.lockNo, // 锁编号
              digitalSignature: this.digitalSignature, // 数字签名
            }).then(res => {
              // 加载框取消
              this.fullLoading.close();
              // 解构res.data
              const { result, msg } = res.data;
              // 解析后台返回的结果集，判断是否成功
              if (result) {
                // 操作成功
                this.$message.success(msg);
                // 返回一览
                this.$parent.fun_Back();
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
              // 关闭loading
              this.loading = false;
            });
          } catch (e) {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("操作失败！" + e);
            // 加载框取消
            this.fullLoading.close();
          }
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.calockDialog {
  .el-dialog__body {
    .btnList {
      display: flex;
      justify-content: center;
      li {
        width: 170px;
        line-height: 36px;
        text-align: center;
        border-radius: 3px;
        border: 1px solid #C9C9C9;
        background: #F0F2F5;
        margin-right: 20px;
        font-size: 16px;
        color: #666666;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
      .activeLi {
        background: #0E70B5 !important;
        color: #ffffff;
        border: none;
      }
    }
    .wordDecrypt {
      text-align: center;
      display: flex;
      flex-direction: column;
      padding: 0 8px 80px;
      .tips {
        color: #333333;
        font-weight: bold;
        padding: 30px 0 30px;
        display: flex;
        justify-content: center;
        font-size: 16px;
      }
      /deep/.el-form {
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
      .el-input {
        width: 100%;
      }
      .el-button {
        margin-top: 12px;
      }
      .tip {
        color: #E57302;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 0;
        cursor: pointer;
        .el-icon-info {
          font-size: 20px;
          margin-left: 3px;
        }
      }
    }
    .codeDecrypt {
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 0 20px 20px;
      .app {
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          &:first-child {
            margin-bottom: 5px;
          }
          &:last-child {
            margin-top: 6px;
          }
        }
        .title{
          font-weight: bold;
          font-size: 14px;
          color: rgba(0,0,0,0.85) !important;
          line-height: 11px;
        }
        .text {
          font-weight: 400;
          font-size: 12px;
          color: #999999 !important;
          line-height: 18px;
        }
        .down {
          a {
            font-weight: bold;
            font-size: 12px;
            color: #4063E9 !important;
            line-height: 11px;
          }
          span {
            color: #666666;
            font-weight: bold;
          }
        }
      }
      .interconnectionShow,
      .newPointShow {
        margin-left: 40px;
        .tip {
          span {
            margin-top: 2px;
          }
        }
      }
      .newPointShow,
      .standardSignalShow,
      .interconnectionShow {
        margin-top: 50px;
        text-align: center;
        img {
          cursor: pointer;
        }
        .tip {
          span {
            color: #333333 !important;
          }
        }
      }
      .codeImg {
        margin-top: 15px;
        display: flex;
        justify-content: center;
        cursor: pointer;
      }
      .tip {
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          color: #333333;
          margin-top: 5px;
          &:first-child {
            color: red;
            cursor: pointer;
          }
        }
      }
    }
    .btn {
      position: absolute;
      right: 20px;
      bottom: 20px;
    }
  }
}
</style>
